import { graphql } from 'src/graphql';

export const AccessoryFragment = graphql(`
  fragment AccessoryFragment on AccessoryCategoryV2 {
    categoryName
    productCount
    product {
      id
      primaryImage {
        id
      }
      productType {
        productTypeId
      }
    }
    productTypeSlug
  }
`);

export const AccessoryCategoriesQuery = graphql(
  `
    # arguments are the same, but one query requires ID type and second one requires Int :/
    query AccessoryCategoriesQuery(
      $id: ID
      $productId: Int!
      $language: String
      $subsidiary: Subsidiary
    ) {
      product(id: $id) {
        name
        slug
        subProducts {
          isMainProduct
          product {
            slug
          }
        }
        primaryImage {
          id
        }
      }
      accessories(productId: $productId, language: $language, subsidiary: $subsidiary) {
        ...AccessoryFragment
      }
    }
  `,
  [AccessoryFragment]
);
